module.exports = __webpack_public_path__ + "img/new-ui-guiding.1bc9095b.svg";